export default __webpack_public_path__ + "static/media/nab-chairman.e02349dc.png";